import { render, staticRenderFns } from "./ProductTag.vue?vue&type=template&id=625c1d86"
import script from "./ProductTag.vue?vue&type=script&lang=js"
export * from "./ProductTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports